import { awareness } from './awareness';
import { camo } from './camo';
import { modern } from './modern';
import { patriotic } from './patriotic';
import { throwback } from './throwback';
import { traditional } from './traditional';
import { flannel } from './flannel';
import { pinstripe } from './pinstripe';
import { triton_connect } from './triton_connect';
import { seamhead } from './seamhead';

export const softball = {
  traditional,
  throwback,
  modern,
  pinstripe,
  flannel,
  patriotic,
  camo,
  awareness,
  triton_connect,
  seamhead,
};
